
// Dialogs always render into <body> while they are open: a `position: fixed`
// box resolves against the nearest transformed/filtered ancestor rather than
// the viewport, and several places (the entry editor sidebar, the AI chat
// panel) do use a transform. Rendering in place would then centre the dialog
// inside that ancestor instead of the window.
export default {
	name: 'Dialog',
	props: {
		width: Number,
		height: Number,
	},
	data: () => ({
		isOpen: false,
		callback: null,
	}),
	computed: {
		style() {
			return {
				width: this.width ? this.width + 'px' : undefined,
				height: this.height ? this.height + 'px' : undefined,
			}
		},
	},
	methods: {
		open(callback = null) {
			this.isOpen = true
			this.callback = callback
			document.body.classList.add('DialogOpen')
			this.$nextTick(() => document.body.appendChild(this.$el))
		},
		close(result = null) {
			this.isOpen = false
			if (this.callback) this.callback(result)
			document.body.classList.remove('DialogOpen')
			this.$emit('close')
		},
		cancel() {
			this.close()
			this.$emit('cancel')
		},
		onWheel(e) {
			e.stopPropagation()
			e.preventDefault()
			return false
		},
	},
	// TODO: key listener for ESC
	beforeDestroy() {
		document.body.classList.remove('DialogOpen')
		// we moved the element out of the parent's control, so clean it up ourselves
		this.$el?.parentNode?.removeChild(this.$el)
	},
}
